// @ts-nocheck
class KlaviyoBisButton extends HTMLElement {
  constructor() {
    super();

    this.addedFunc = [];
    this.ELM_productInfoWrapper = document.querySelector(
      ".product__info-wrapper"
    );
    this.triggerButton = document.querySelector(".klaviyo-bis-trigger-custom");
    this.initBISWaitlistButton();

    this.buttonTitles = {
      'oos-text': 'Sold out - Join waitlist',
      'coming-soon-text': 'Coming soon - Join waitlist',
    }
  }

  resetDefaultButtonTitle() {
    for (let t in this.buttonTitles) {
      const span = document.querySelector(`.${t}`);
      if (span) span.textContent = this.buttonTitles[t];
    }
  }

  removeAllListeners() {
    const buttons = this.querySelectorAll("button") || [];
    buttons.forEach((b) => {
      this.addedFunc.forEach((f) => {
        b.removeEventListener("click", f);
      });
    });
  }

  bindAndStoreFuncs(func) {
    const bindFunc = func.bind(this);

    this.addedFunc.push(bindFunc);
    return bindFunc;
  }

  BISWaitlistReset(t) {
    let content = document.querySelector("#bis-subscribe-waitlist");
    content.style.maxHeight = 0;
    content.classList.remove("expanded");
    this.removeAllListeners();
    this.resetDefaultButtonTitle();

    this.triggerButton = document.querySelector(".klaviyo-bis-trigger-custom");
    if (this.triggerButton) {
      this.triggerButton.removeAttribute('disabled');
    }

    [
      ...document.querySelectorAll('.bis-subscribe input[type="text"]'),
      ...document.querySelectorAll('.bis-subscribe input[type="email"]'),
    ].forEach((i) => (i.value = ""));
  }

  initBISWaitlistButton() {
    const bindOneTimeExpand = this.bindAndStoreFuncs(this.oneTimeExpand);
    this.triggerButton = document.querySelector(".klaviyo-bis-trigger-custom");

    if (this.triggerButton) {
      this.removeAllListeners();
      this.triggerButton.addEventListener("click", bindOneTimeExpand);
    }
  }

  oneTimeExpand() {
    this.triggerButton = document.querySelector(".klaviyo-bis-trigger-custom");

    let content = document.querySelector("#bis-subscribe-waitlist");
    content.style.maxHeight = content.scrollHeight + "px";

    this.triggerButton.classList.add("expanded");
    this.removeAllListeners();

    const bindJoinWaitlist = this.bindAndStoreFuncs(this.joinWaitlist);
    this.triggerButton.addEventListener("click", bindJoinWaitlist);
  }

  joinWaitlist() {
    this.clearAllErrorMessages();

    let bis_form = document.querySelector("#bis-subscribe-waitlist");
    const variant_id = document.querySelector(".product-variant-id").value;

    const mail = bis_form.querySelector("#bis-user-email")?.value;
    const phone = bis_form.querySelector("#bis-user-phonenumber")?.value;
    const phone_prefix = bis_form.querySelector(
      "#bis-user-phone_prefix"
    )?.value;
    const sms_consent = bis_form.querySelector("#send_sms")?.checked;
    const subscription = bis_form.querySelector("#subscription")?.checked;

    if (
      !this.isValid({
        mail,
        phone,
        consent: sms_consent,
        phone_prefix: phone_prefix,
      })
    ) {
      return;
    }

    const formatted_phone = () => {
      let str = phone;
      let prefix = phone_prefix

      if (!prefix.includes('+')) {
        prefix = '+' + prefix;
      }

      if (str.length === 10 && str[0] == 0) {
        str = str.substring(1);
      }
      
      return prefix + str;
    };


    if (subscription) {
      this.subscribe({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: mail,
                  ...(phone ? { phone_number: formatted_phone() } : {})
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "Y6zah5",
              },
            },
          },
        }
      });
    }

    this.subscribeBackInStock({
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: mail,
                ...(sms_consent ? { phone_number: formatted_phone() } : {}),
              },
            },
          },
          channels: ["EMAIL", ...(sms_consent ? ["SMS"] : [])],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variant_id}`,
            },
          },
        },
      },
    });
  }

  isValid({ mail, phone, consent, phone_prefix }) {
    let isValid = true;

    if (!mail) {
      this.showError("email", "Please input your mail");
      isValid = false;
    } else if (mail && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(mail)) {
      this.showError("email", "Your mail is invalid!");
      isValid = false;
    } else {
      this.showError("email", "");
    }

    if (consent) {
      if (!phone) {
        this.showError("phonenumber", "Please input your phone number");
        isValid = false;
      } else if (
        !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(phone)
      ) {
        this.showError("phonenumber", "Your phone number is invalid!");
        isValid = false;
      } else {
        this.showError("phonenumber", "");
      }

      if (!phone_prefix) {
        this.showError("phone_prefix", "Invalid!");
        isValid = false;
      } else this.showError("phone_prefix", "");
    }

    return isValid;
  }

  async subscribeBackInStock(data) {
    this.toggleDisable();
    const texts = document.querySelectorAll(
      "button.klaviyo-bis-trigger-custom span"
    ) || [];
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=Minknx`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        revision: "2024-10-15",
        Authorization: "Klaviyo-API-Key pk_943cb900c381d9a483de5a25896b08b2d2",
        "content-type": "application/vnd.api+json",
      },
      body: JSON.stringify(data),
    });

    this.toggleDisable();
    if (response.ok) {
      this.triggerButton.setAttribute('disabled', true);

      texts.forEach(t => {
        if (t.checkVisibility()) t.textContent = "SUBMITTED";
      })
    } else {
      const res = await response.json();
      const error_message = res.errors[0]?.detail;
      const splitted = res.errors[0]?.source?.pointer.split("/");

      if (splitted[splitted.length - 1] === "phone_number") {
        document.querySelector("#bis-res-error-phonenumber").textContent =
          error_message;
      }
    }
  }

  async subscribe(data) {
    const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=Minknx', {
      method: "POST",
      headers: {
        revision: "2024-10-15",
        Authorization: "Klaviyo-API-Key pk_943cb900c381d9a483de5a25896b08b2d2",
        "content-type": "application/vnd.api+json",
      },
      body: JSON.stringify(data),
    });
  }

  clearAllErrorMessages() {
    const errors = [
      ...(document.querySelectorAll("[id^=bis-error-]") || []),
      ...(document.querySelectorAll("[id^=bis-res-error-]") || []),
    ];

    errors.forEach((e) => (e.textContent = ""));
  }

  showError(field, message) {
    document
      .querySelector(`#bis-user-${field}`)
      ?.classList.toggle("field-error", !!message);
    document.querySelector(`#bis-error-${field}`).textContent = message;
  }

  toggleDisable() {
    const DISABLED = "disabled";
    this.ELM_productInfoWrapper.classList.toggle("product-info-loading");

    if (this.triggerButton.getAttribute(DISABLED))
      this.triggerButton.removeAttribute(DISABLED);
    else this.triggerButton.setAttribute(DISABLED, true);
  }
}

customElements.define("klaviyo-bis-button", KlaviyoBisButton);
